import BBPromise from 'bluebird';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

// Polyfill for Fetch for super old chrome.
import 'unfetch/polyfill';

import { initLogRocket } from 'shared/utils/shared-boot-helpers';
import PublicEnv from 'shared/utils/public-env';
import { initializeRum } from 'src/utils/rum';
import Root, { initializeLDProvider } from 'src/root';

// CURRENT_VERSION is replaced by Webpack & represents the version of the JS at build time
// eslint-disable-next-line no-undef
const currentVersion = CURRENT_VERSION;

initializeRum(currentVersion);

BBPromise.config({ cancellation: true });

initLogRocket(PublicEnv.logrocketIdAdmin);

document.addEventListener('DOMContentLoaded', async () => {
  const renderTarget = document.getElementById('render-target');
  Modal.setAppElement(renderTarget);

  // Initialize LaunchDarkly before rendering to ensure flags are available
  const LDProvider = await initializeLDProvider();

  ReactDOM.render(
    <LDProvider>
      <Root currentVersion={currentVersion} />
    </LDProvider>,
    renderTarget
  );
});
